module.exports = __webpack_public_path__ + "static/media/29.16f33200.mp3";